module.exports = __webpack_public_path__ + "static/rain-bg-468f73e0373429c008ee3376e62d0e0b.png";